// Copyright (C) 2017-2023 Smart code 203358507

const React = require('react');

const ServicesContext = React.createContext({});

ServicesContext.displayName = 'ServicesContext';

module.exports = ServicesContext;
